var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.278 17.532h17.445c1.081 0 1.492-.65 1.617-.923s.341-1.014-.376-1.833l-8.358-9.577c-.82-.932-2.391-.932-3.212 0l-8.369 9.577c-.706.82-.49 1.56-.364 1.833.125.274.535.923 1.617.923zM24.723 19.456H7.277A2.277 2.277 0 0 0 5 21.734v3.416a2.284 2.284 0 0 0 2.277 2.277h17.446A2.284 2.284 0 0 0 27 25.15v-3.416a2.277 2.277 0 0 0-2.277-2.278z",
    fill: "#FFE14B",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.75fab487f5b5925e60ed04181efeb0aa.svg";
export { ForwardRef as ReactComponent };